export default __webpack_public_path__ + "static/chicago.skyline.3-2e88541175e924eae2bcc66ef92b1f88.svg";